<template>
    <div class="review-cost">
        <ProgressBar
            :current-step="2"
        />
        <div class="review-cost__content">
            <div v-if="this.$store.getters.isPrepayment">
                <h1>
                    Your order has been found. Let's review your cost.
                </h1>
                <p>
                    Your provider selected the self-pay option for this test. Here's what that means for your cost and the options available to you.
                </p>
            </div>
            <div v-else>
                <h1 class="header--small">
                    Your order has been found.
                </h1>
                <p>
                    Your provider selected insurance billing for this test. Here's what that means for your cost.
                </p>
            </div>
            <ReviewCostInfo />
            <ReviewFinancialOptions />
        </div>
    </div>
</template>

<script>
import ProgressBar from "../components/ui/ProgressBar.vue";
import ReviewCostInfo from "../components/layout/Payment/ReviewCostInfo.vue";
import ReviewFinancialOptions from "../components/layout/Payment/ReviewFinancialOptions.vue";

export default {
    name: "PaymentReviewCost",
    components: {
        ProgressBar,
        ReviewCostInfo,
        ReviewFinancialOptions
    },
    mounted() {
        this.$store.dispatch("setShowStartupLoader", false);
    },
    methods: {
        
    }
};
</script>

<style lang="scss" scoped>

.review-cost {
    @include site-section();

    text-align: center;
    padding-bottom: 50px;

    h1 {
        color: #000;
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hxl, 36px);
        font-style: normal;
        font-weight: 400;
        line-height: 122%; /* 43.92px */
        letter-spacing: -0.72px;
        margin-bottom: 8px;

        &.header--small {
            font-size: var(--font-size-hm, 24px);
            font-style: normal;
            font-weight: 700;
            line-height: 133%; /* 31.92px */
            letter-spacing: -0.48px;
        }
    }

    p {
        color: var(--Primary-Grey---Copy-Black, #333);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hs, 20px);
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 30px */
        letter-spacing: -0.2px;
        max-width: 816px;
        margin-left: auto;
        margin-right: auto;
    }
}

@include small-desktop() {
    .review-cost {
        @include site-section-sm-desktop();
    }
}

@include sm() {
    .review-cost {
        h1 {
            font-size: 24px;
        }

        p {
            font-size: 16px;
        }
    }
}

@media (max-width: 400px) {
    .review-cost {
        h1 {
            &.header--small {
                font-size: 20px;
            }
        }
    }
}
</style>
